import vue from "vue";
import app from "./App.vue";
import router from "./router";
import authentication from "./authentication";
import store from "./store";
import "@progress/kendo-theme-default/dist/all.css";
import { Grid } from "@progress/kendo-vue-grid";
import "vue-snotify/styles/material.css";
import underscore from 'vue-underscore';
import snotify, { SnotifyPosition } from "vue-snotify";
import vuetify from "./plugins/vuetify";
const options = {
    toast: {
        position: SnotifyPosition.rightTop
    }
}
vue.use(snotify, options);
vue.use(underscore);

vue.component('Grid', Grid);

vue.config.productionTip = false;

authentication.initialize().then(() => {
// ReSharper disable once InconsistentNaming
    new vue({
        router,
        store,
        vuetify,
        render: h => h(app)
    }).$mount('#app');
});
